<template>
<div
  v-cloak
  class="videoletterProductDetail"
  :data-loading="isLoading"
  ref="videoletterProductDetail"
>
  <app-loading class="videoletterProductDetail__loading" :is-loading="isLoading"></app-loading>
  <div class="container" style="position: relative">
    <span class="videoletterProductDetail__close" @click="close"></span>
    <div class="productHeader">
      <div class="u-tx-center">
        <br><br>
      </div>
    </div>
    <div class="productBody">

      <div class="card u-mg-b-2 product" ref="productInformation">
        <div class="card__media product__media" v-if="hasSample">
          <store-video-player
            ref="videoPlayer"
            :options="videoOptions">
          </store-video-player>
        </div>
        <div class="card__body">
          <div class="product__title">
            <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="itemDetail.image_url" :alt="itemDetail.item_name"></uranai-img>
            <h2>{{ itemDetail.item_name }}</h2>
          </div>

          <p class="u-tx-bold u-tx-brand u-mg-0" v-if="isArrival(itemDetail)">
            <small>応募受付中</small>　残り{{ getRemaining(itemDetail) }}人
          </p>

          <div class="product__pricing">
            <div class="priceMain">
              <span v-price="itemDetail.price_taxin"></span>
              <small>（税込）/１回</small>
            </div>
            <div class="asideBaloon">お支払い後<br>2週間程度でお届け</div>
          </div>
        </div>

        <p class="product__description" v-html="nl2br(itemDetail.selling_point)"></p>

        <a :href="nextUrl" class="btn  u-mg-b-2"
          :data-disabled="isDisabled"
          data-block="true"
          data-color="pink_active"
        >{{ ctaMessage }}</a>
      </div>

      <div class="firstcome-detail__link position-bottom"><a href="/lp/movie_plannings">占いビデオレターとは</a></div>

      <div class="card u-mg-b-2">
        <div v-if="hasItem(recommend.data)">
          <h4 class="card__heading">現在、申込み可能なビデオレター</h4>
          <div class="arrivaleVideoletter">
            <div class="arrivaleVideoletter__listGroup">
              <a @click.prevents="changeDetail(item.items_id)"
                v-for="(item, index) in recommend.data" :key="item.items_id">
                <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="item.image_url"></uranai-img>
              </a>
            </div>
            <div class="arrivaleVideoletter__more readMore"
              v-if="recommend.total > recommend.per_page">
              <a href="/movie/firstcome">もっと見る</a>
            </div>
          </div>
        </div>

        <div v-if="hasItem(summary.data)">
          <h4 class="card__heading">SUMMARY</h4>
          <div data-size="sm" data-border="false" class="listGroup">
            <div class="listGroup__body row">
              <ul class="u-mg-r-2">
                <li class="listGroup__item" v-for="(item, index) in summary.data" :key="item.items_id" data-arrow="true">
                  <a :href="summaryURL(item.items_id)" class="media g-summaryText">
                    <div class="media__image" data-size="md">
                      <uranai-img data-clip-path-support="true" data-size="md" size="md" :src="item.pack_image"></uranai-img>
                    </div>
                    <div class="media__content">
                      <div class="badge" data-color="white">
                        <span>無料</span>
                      </div>
                      <h5 class="media__title u-mg-b-1 u-mg-t-1" v-html="item.name"></h5>
                      <div class="media__description">
                        <p v-html="item.menu_name"></p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div class="listGroup__footer readMore"
              v-if="summary.total > summary.per_page">
              <a href="/">もっと見る</a>
            </div>
          </div>
        </div>
      </div>
      <div class="card u-mb-b-2">
        <h4 class="card__heading">今すぐ占える姉妹サービス</h4>
        <a class="banner" href="https://app.adjust.com/ece41y_l5noxp?campaign=from_tvstore&adgroup=profile&creative=chapli_01" target="_blank">
          <img src="/static/img/banner/chapli.png" alt="Chapli">
        </a>
        <a class="banner" href="https://roba3.com/campaign/index/?cpno=1700817965&utm_medium=CRM&utm_source=official&utm_campaign=uranaitv_store" target="_blank">
          <img src="/static/img/banner/robamimi.png" alt="ロバミミ">
        </a>
      </div>
    </div>

  </div>
</div>
</template>

<script>
const location = `${window.location.origin}/`

/**
  * summary表示用 6桁にゼロパディング
  * @param { Number } id - items_id
  */
function zeroPadding(id = 0) {
  if (isNaN(Number(id) || !id)) {
    id = 0
  }
  return (`000000${id}`).slice(-6)
}

export default {
  name: 'videoletter-product-detail',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    active: Boolean
  },
  data: () => ({
    itemDetail: {},
    recommend: {},
    summary: {},
  }),
  watch: {
    detail: {
      handler() {
        if (
          'firstcome' in this.detail &&
          'recommend' in this.detail &&
          'summary' in this.detail
        ) {
          this.$set(this, 'itemDetail', this.detail.firstcome.data[0])
          this.$set(this, 'recommend', this.detail.recommend)
          this.$set(this, 'summary', this.detail.summary)
          // 一番上までスクロール
          window.scrollTo(0, 0)
        } else {
          this.$set(this, 'itemDetail', {})
          this.$set(this, 'recommend', {})
          this.$set(this, 'summary', {})
        }
        let $productInformation = this.$refs.productInformation || {}
        let width = $productInformation.clientWidth || 375
        let height = width * (9 / 16)

        this.videoOptions = {
          title: `【サンプル】${this.itemDetail.item_name}`,
          sources: [{
            type: 'video/mp4',
            src: this.itemDetail.sample_url,
          }],
          fluid: false,
          width,
          height,
          poster: this.itemDetail.sample_thumbnail
        }
      }
    }
  },

  computed: {
    isLoading() {
      return !this.detail.firstcome
    },
    /**
     * 申し込みリンクへのボタンの活性・非活性の判定
     * @return { Boolean }
     *
     * - items_id: truthy
     * - is_active: truthy
     * - is_arrival: truthy
     * - (応募上限数 - 応募総数) > 0
     **/
    isDisabled() {
      return !(
        this.itemDetail.items_id &&
        this.itemDetail.is_active &&
        this.itemDetail.is_arrival &&
        this.getRemaining(this.itemDetail) > 0
      )
    },
    hasSample() {
      // サムネとサンプル動画両方ある場合のみサンプル表示フラグを立てる
      return !!this.itemDetail.sample_url && !!this.itemDetail.sample_thumbnail
    },
    nextUrl() {
      // 入力ページへのリンク作成
      let url = `/movie/firstcome/profile/${('000000' + this.itemDetail.items_id).slice(-6)}`
      url += window.location.search
      return url
    },
    ctaMessage() {
      return this.isDisabled ? '現在受け付けしておりません' : '相談内容を入力して申し込む'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    getRemaining(item) {
      return item.max_order - item.orders_count || 0
    },
    isArrival(item) {
      return this.getRemaining(item) > 0 && item.is_arrival
    },
    nl2br(string = '') {
      string = !string ? '' : string
      return string.replace(/\n/g, '<br>')
    },
    recommendURL(items_id) {
      return `/movie/firstcome/detail/${items_id}`
    },
    changeDetail(items_id) {
      this.$emit('change', items_id)
    },
    summaryURL(items_id) {
      let itemsId = zeroPadding(items_id)
      return `/contents/${itemsId}`
    },
    /**
     * レコメンド系
     * 要素があるかどうかをBooleanで返却
     * @param { Object } data -
     * @return { Boolean }
     **/
    hasItem(data) {
      if (!data) {
        return false
      }
      return data.length > 0
    }
  }
}</script>

<style lang="scss" scoped>
@keyframes showModal {
  0% {
    transform: translate3d(0, 100%, 0);
    display: block;
  }
  100% {
    transform: translate3d(0, 0, 0);
    display: block;
  }
}

@keyframes closeModal {
  0% {
    display: block;
    transform: translate3d(0, 0, 0);
  }
  99.999% {
    display: block;
    transform: translate3d(0, 100%, 0);
  }
  100% {
    display: none;
    transform: translate3d(0, 100%, 0);
  }
}

.videoletterProductDetail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FFF;
  will-change: transform;
  z-index: 100;
  backface-visibility: hidden;
  transform: translate3d(0, 100%, 0);
  animation: closeModal 300ms ease-in-out 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 88px;
  &__close {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 24px;
    height: 24px;
    display: block;
    cursor: pointer;
    &::before,
    &::after {
      content: '';
      width: 2px;
      height: 28px;
      background: #FFF;
      display: block;
      position: absolute;
      top: 0;
      left: 11px;
    }
    &::before {
      transform: rotate(45deg)
    }
    &::after {
      transform: rotate(-45deg)
    }
  }
  &[data-active='true'] {
    animation: showModal 300ms ease-in-out 1ms forwards;
    .container {
      display: block;
    }
  }
  &[data-loading='true'] {
    &::after {
      content: '';
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.75);
    }
    .videoletterProductDetail__loading {
      display: block;
    }
  }
  &__loading {
    display: none;
    position: absolute;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .container {
    display: none;
  }
}

.card {
  .media {
    p {
      line-height: 1.2em;
      margin-top: .5em;
      margin-bottom: .5em;
    }

    .divinationMethod {
      color: #888;
      font-size: 11px;
    }

    .itemName {
      margin-top: 0;
      font-weight: bold;
    }

    .price {
      color: #8cc63f;
      font-weight: bold;
      font-size: 14px;
    }

  }

  &__heading {
    color: #1b1761;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: .5em;
  }
}

.banner {
  display: block;
  margin-bottom: 1em 0;
  img {
    width: 100%;
  }
}

.arrivaleVideoletter {
  margin: 1em 0 2em;
  &__listGroup {
    display: flex;
    justify-content: space-around;
    margin-bottom: 1em;
  }
}
.readMore {
  text-align: right;
}

.product {
  &__media {
    margin-bottom: 20px;
  }
  &__title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .uranaiImg {
      margin-right: 12px;
      flex-shrink: 0;
    }
    h2 {
      margin: 0;
      font-weight: 500;
      font-size: 20px;
      line-height: 1.2;
    }
  }
  &__pricing {
    display: flex;
    margin: 8px 0;
    .priceMain {
      font-weight: 500;
      font-size: 24px;
      margin: 0;
      small {
        font-size: 14px;
      }
    }
    .asideBaloon {
      font-size: 11px;
      line-height: 14px;
      background: #F8F8F8;
      display: flex;
      align-items: center;
      padding: 0 12px;
      height: 40px;
      border-radius: 4px;
      position: relative;
      margin-left: 1.5em;
      &::after {
        content: '';
        position: absolute;
        left: -4.5px;
        top: 50%;
        margin-top: -4.5px;
        width: 10px;
        height: 10px;
        background: inherit;
        display: block;
        transform: rotate(45deg);
      }
    }
  }
  &__description {
    margin: 20px 0;
    color: #888;
    font-size: 13px;
    line-height: 1.5;
  }

}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/VideoletterProductDetail.vue